export default __webpack_public_path__ + "static/media/Modal_EFFECT.b90a36a4.jpg";